import React from "react";

class WebHealthAPI {
  constructor() {
    this.isReactNativeWebView = !!window.ReactNativeWebView;
    this.messageListeners = new Map();
    this.setupMessageListener();
    this.pendingPromises = new Map();
  }

  // 네이티브에서 오는 메시지 리스너 설정
  setupMessageListener() {
    //console.loglog('🎧 메시지 리스너 설정 시작...');
    //console.loglog('🌐 WebView 환경:', this.isReactNativeWebView);

    if (this.isReactNativeWebView) {
      const handleMessage = (event) => {
        try {
          //console.loglog('📨 원본 이벤트 받음:', event);
          //console.loglog('📨 원본 이벤트 받음 typeof :', typeof event);
          //console.loglog('📨 이벤트 데이터:', event.data);

          const message = typeof event.data === 'object' ? event.data : JSON.parse(event.data);
          //console.loglog('📨 파싱된 메시지:', message);
          //console.loglog('📨 메시지 타입:', message.type);

          // 리스너 함수 직접 가져오기 (객체가 아닌 함수)
          const listenerFunction = this.messageListeners.get(message.type);
          //console.loglog('🎯 리스너 함수 찾음:', !!listenerFunction);
          //console.loglog('🎯 리스너 타입:', typeof listenerFunction);

          if (listenerFunction && typeof listenerFunction === 'function') {
            //console.loglog('✅ 리스너 함수 실행 중...');

            // 함수 직접 호출
            listenerFunction(message);

            // once 플래그 확인하여 제거
            if (listenerFunction.once) {
              //console.loglog('🗑️ 일회성 리스너 제거:', message.type);
              this.messageListeners.delete(message.type);
            }
          } else {
            //console.logwarn('⚠️ 리스너가 함수가 아니거나 존재하지 않음:', typeof listenerFunction);
            //console.logwarn('⚠️ 현재 등록된 리스너들:', Array.from(this.messageListeners.keys()));
          }
        } catch (error) {
          //console.logerror('💥 메시지 파싱 오류:', error);
          //console.logerror('💥 원본 데이터:', event.data);
        }
      };

      // 여러 방식으로 이벤트 리스너 등록
      //console.loglog('📝 document에 message 이벤트 리스너 등록');
      document.addEventListener('message', handleMessage);

      //console.loglog('📝 window에 message 이벤트 리스너 등록');
      window.addEventListener('message', handleMessage);

      //console.loglog('✅ 모든 메시지 리스너 설정 완료');
    } else {
      //console.logwarn('⚠️ React Native WebView 환경이 아님 - 리스너 설정 건너뜀');
    }
  }

  // 네이티브에 메시지 전송
  sendMessageToNative(message) {
    //console.loglog('📤 네이티브로 메시지 전송:', message);

    if (this.isReactNativeWebView) {
      //console.loglog('📤 ReactNativeWebView 객체:', window.ReactNativeWebView);
      //console.loglog('📤 postMessage 함수:', typeof window.ReactNativeWebView.postMessage);

      try {
        const messageString = JSON.stringify(message);
        //console.loglog('📤 직렬화된 메시지:', messageString);

        window.ReactNativeWebView.postMessage(messageString);
        //console.loglog('✅ 메시지 전송 완료');

      } catch (error) {
        //console.logerror('💥 메시지 전송 오류:', error);
      }
    } else {
      //console.logwarn('React Native WebView 환경이 아닙니다.');
      // 테스트용 더미 응답
      this.simulateNativeResponse(message);
    }
  }

  requestAndroidWeeklySteps() {
    // Android이고 웹뷰일 때만 실행
    if (this.isReactNativeWebView) {
      // console.log('📤 안드로이드 DB 데이터 요청 전송');
      this.sendMessageToNative({ type: 'STEP_GET_WEEKLY' });
    }
  }


  // 테스트용 더미 응답 시뮬레이션 - Android 지원 추가
  simulateNativeResponse(originalMessage) {
    setTimeout(() => {
      let responseType = '';
      let responseData = {};

      switch (originalMessage.type) {
        case 'HEALTH_INIT':
          responseType = 'HEALTH_INIT_RESPONSE';
          responseData = {
            success: true,
            data: {
              isInitialized: true,
              permissionGranted: true,
              platform: 'web'
            }
          };
          break;

        case 'GET_HEALTH_DATA':
          responseType = 'HEALTH_DATA_RESPONSE';
          responseData = {
            success: true,
            data: {
              value: Math.floor(Math.random() * 10000) + 5000,
              rawData: {
                value: Math.floor(Math.random() * 10000) + 5000,
                startDate: new Date().toISOString(),
                endDate: new Date().toISOString()
              },
              startDate: new Date().toISOString(),
              endDate: new Date().toISOString(),
              // Android 스타일 더미 데이터도 포함
              records: [],
              recordCount: 0,
              hasPermission: true,
              timeRange: {
                start: new Date().toISOString(),
                end: new Date().toISOString()
              }
            }
          };
          break;

        case 'GET_WEEKLY_HEALTH_DATA':
          responseType = 'WEEKLY_HEALTH_DATA_RESPONSE';

          // 7일간 더미 데이터 생성
          const weeklyData = [];
          const today = new Date();

          for (let i = 6; i >= 0; i--) {
            const date = new Date();
            date.setDate(today.getDate() - i);

            const month = date.getMonth() + 1;
            const day = date.getDate();
            const dateLabel = `${month}.${day}`;

            const steps = Math.floor(Math.random() * 8000) + 2000; // 2000-10000 랜덤

            const dayData = {
              date: dateLabel,
              step: steps
            };

            // 오늘이면 day 속성 추가
            if (i === 0) {
              dayData.day = '오늘';
            }

            weeklyData.push(dayData);
          }

          responseData = {
            success: true,
            data: {
              startDate: new Date(today.getTime() - 6 * 24 * 60 * 60 * 1000).toISOString(),
              endDate: today.toISOString(),
              weeklyData,
              // Android 스타일 응답도 포함
              records: [],
              totalSteps: weeklyData.reduce((sum, day) => sum + day.step, 0),
              recordCount: 0,
              hasPermission: true,
              timeRange: {
                start: new Date(today.getTime() - 6 * 24 * 60 * 60 * 1000).toISOString(),
                end: today.toISOString()
              },
              rawResult: { records: [], pageToken: "" }
            }
          };
          break;

        case 'GET_MONTHLY_HEALTH_DATA':
          // 월간 더미 데이터 생성
          const { year, month } = originalMessage;
          const daysInMonth = new Date(year, month, 0).getDate();
          const dailyData = [];

          for (let day = 1; day <= daysInMonth; day++) {
            const steps = Math.floor(Math.random() * 12000) + 3000;
            dailyData.push({
              date: `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`,
              steps: steps,
              calories: Math.round(steps * 0.04),
              distance: parseFloat((steps * 0.0008).toFixed(2))
            });
          }

          const totalSteps = dailyData.reduce((sum, day) => sum + day.steps, 0);

          responseType = 'MONTHLY_HEALTH_DATA_RESPONSE';
          responseData = {
            success: true,
            data: {
              year,
              month,
              startDate: new Date(year, month - 1, 1).toISOString(),
              endDate: new Date(year, month, 0, 23, 59, 59).toISOString(),
              dailyData,
              monthlyStats: {
                totalSteps,
                totalCalories: Math.round(totalSteps * 0.04),
                totalDistance: parseFloat((totalSteps * 0.0008).toFixed(2)),
                activeDays: dailyData.filter(d => d.steps > 0).length,
                avgSteps: Math.round(totalSteps / daysInMonth),
                maxStepsDay: dailyData.reduce((max, day) => day.steps > max.steps ? day : max),
                minStepsDay: dailyData.reduce((min, day) => day.steps < min.steps ? day : min),
                daysInMonth
              },
              // Android 스타일 응답도 포함
              records: [],
              totalSteps: totalSteps,
              recordCount: dailyData.filter(d => d.steps > 0).length,
              hasPermission: true,
              timeRange: {
                start: new Date(year, month - 1, 1).toISOString(),
                end: new Date(year, month, 0, 23, 59, 59).toISOString()
              },
              rawResult: { records: [], pageToken: "" }
            }
          };
          break;

        case 'CHECK_HEALTH_PERMISSION':
          responseType = 'HEALTH_PERMISSION_STATUS';
          responseData = {
            success: true,
            data: {
              isInitialized: true,
              permissionGranted: true,
              platform: 'web'
            }
          };
          break;

        default:
          return;
      }

      const listenerFunction = this.messageListeners.get(responseType);
      if (listenerFunction && typeof listenerFunction === 'function') {
        listenerFunction(responseData);
        if (listenerFunction.once) {
          this.messageListeners.delete(responseType);
        }
      }
    }, 2000);
  }

  // Promise 기반 메시지 전송
  sendMessageWithPromise(message, responseType, timeout = 30000) {
    // ★ 동일 responseType의 pending Promise가 있으면 재사용
    if (this.pendingPromises.has(responseType)) {
      return this.pendingPromises.get(responseType);
    }

    const promise = new Promise((resolve, reject) => {
      const timeoutId = setTimeout(() => {
        this.messageListeners.delete(responseType);
        this.pendingPromises.delete(responseType); // ★ 정리
        reject(new Error('응답 시간 초과'));
      }, timeout);

      const listenerFunction = (response) => {
        clearTimeout(timeoutId);
        this.pendingPromises.delete(responseType); // ★ 정리

        if (response.type === 'HEALTH_PERMISSION_REQUEST_RESPONSE') {
          resolve(response);
        } else if (response.success) {
          resolve(response.data);
        } else {
          reject(new Error(response.error || '알 수 없는 오류'));
        }
      };

      listenerFunction.once = true;
      this.messageListeners.set(responseType, listenerFunction);
      this.sendMessageToNative(message);
    });

    this.pendingPromises.set(responseType, promise); // ★ 등록
    return promise;
  }

  // 재시도 로직이 포함된 메시지 전송
  async sendMessageWithRetry(message, responseType, maxRetries = 3, timeout = 30000) {
    maxRetries = 1;

    for (let attempt = 1; attempt <= maxRetries; attempt++) {
      try {
        //console.loglog(`🔄 시도 ${attempt}/${maxRetries}:`, message.type);
        const result = await this.sendMessageWithPromise(message, responseType, timeout);
        //console.loglog(`✅ ${attempt}번째 시도 성공:`, result);
        return result;
      } catch (error) {
        //console.logerror(`❌ ${attempt}번째 시도 실패:`, error.message);

        if (attempt === maxRetries) {
          throw new Error(`${maxRetries}번 시도 후 실패: ${error.message}`);
        }

        // 재시도 전 대기 (2초씩 늘어남)
        // await new Promise(resolve => setTimeout(resolve, attempt * 2000));
      }
    }
  }

  // 건강 데이터 초기화
  async initializeHealthData() {
    try {
      //console.loglog('🏥 건강 데이터 초기화 시작...');
      const result = await this.sendMessageWithRetry(
        { type: 'HEALTH_INIT' },
        'HEALTH_INIT_RESPONSE',
        3,
        30000
      );
      //console.loglog('🏥 건강 데이터 초기화 완료:', result);
      return result;
    } catch (error) {
      //console.logerror('🏥 건강 데이터 초기화 실패:', error);
      throw error;
    }
  }

  // 건강 데이터 가져오기
  async getHealthData() {
    try {
      //console.loglog('📊 건강 데이터 조회 시작...');
      const result = await this.sendMessageWithRetry(
        { type: 'GET_HEALTH_DATA' },
        'HEALTH_DATA_RESPONSE',
        3,
        30000
      );
      //console.loglog('📊 건강 데이터 조회 완료:', result);
      return result;
    } catch (error) {
      //console.logerror('📊 건강 데이터 조회 실패:', error);
      throw error;
    }
  }

  // 권한 상태 확인
  async checkPermissionStatus() {
    try {
      //console.loglog('🔐 권한 상태 확인 시작...');
      const result = await this.sendMessageWithRetry(
        { type: 'CHECK_HEALTH_PERMISSION' },
        'HEALTH_PERMISSION_STATUS',
        2,
        20000
      );
      //console.loglog('🔐 권한 상태 확인 완료:', result);
      return result;
    } catch (error) {
      //console.logerror('🔐 권한 상태 확인 실패:', error);
      throw error;
    }
  }

  // 권한 요청 (Android 전용)
  async requestPermission() {
    try {
      console.log('🔓 권한 요청 시작');
      console.log('🔓 메시지 전송:', { type: 'REQUEST_HEALTH_PERMISSION' });

      const result = await this.sendMessageWithRetry(
        { type: 'REQUEST_HEALTH_PERMISSION' },
        'HEALTH_PERMISSION_REQUEST_RESPONSE',
        2,
        45000
      );

      console.log('🔓 수신한 result:', result);
      console.log('🔓 result.granted:', result?.granted);

      return {
        granted: result?.granted === true,
        message: result?.message || ''
      };
    } catch (error) {
      console.error('🔓 권한 요청 에러:', error);
      throw error;
    }
  }

  // 7일간 건강 데이터 가져오기
  async getWeeklyHealthData() {
    try {
      //console.loglog('📊 7일간 건강 데이터 조회 시작...');
      const result = await this.sendMessageWithRetry(
        { type: 'GET_WEEKLY_HEALTH_DATA' },
        'WEEKLY_HEALTH_DATA_RESPONSE',
        3,
        30000
      );
      //console.loglog('📊 7일간 건강 데이터 조회 완료:', result);
      return result;
    } catch (error) {
      //console.logerror('📊 7일간 건강 데이터 조회 실패:', error);
      throw error;
    }
  }

  // 월간 건강 데이터 가져오기
  async getMonthlyHealthData(year, month) {
    try {
      //console.loglog(`📅 월간 건강 데이터 조회 시작: ${year}년 ${month}월`);

      const result = await this.sendMessageWithRetry(
        {
          type: 'GET_MONTHLY_HEALTH_DATA',
          year: year,
          month: month
        },
        'MONTHLY_HEALTH_DATA_RESPONSE',
        3,
        45000 // 월간 데이터는 더 오래 걸릴 수 있음
      );

      //console.loglog('📅 월간 건강 데이터 조회 완료:', result);
      return result;
    } catch (error) {
      //console.logerror('📅 월간 건강 데이터 조회 실패:', error);
      throw error;
    }
  }
}

// 싱글톤 인스턴스 생성
const webHealthAPI = new WebHealthAPI();

// 사용하기 쉬운 함수들로 export
export const healthAPI = {
  // 건강 데이터 초기화
  async init() {
    return await webHealthAPI.initializeHealthData();
  },

  async checkRequiredApps() {
    return await webHealthAPI.sendMessageWithRetry(
      { type: 'CHECK_REQUIRED_APPS' },
      'REQUIRED_APPS_CHECK_RESULT',
      2,
      15000
    );
  },

  requestAndroidWeeklySteps: () => {
    webHealthAPI.requestAndroidWeeklySteps();
  },


  // 오늘의 걸음 수 가져오기
  async getStepCount() {
    return await webHealthAPI.getHealthData();
  },

  // 권한 상태 확인
  async checkPermission() {
    return await webHealthAPI.checkPermissionStatus();
  },

  // 권한 요청
  async requestPermission() {
    return await webHealthAPI.requestPermission();
  },

  // 7일간 걸음수 데이터 가져오기
  async getWeeklyStepCount() {
    return await webHealthAPI.getWeeklyHealthData();
  },

  // 월간 걸음수 데이터 가져오기
  async getMonthlyStepCount(year, month) {
    return await webHealthAPI.getMonthlyHealthData(year, month);
  },


  async checkActualPermission() {
    return await webHealthAPI.sendMessageWithRetry(
      { type: 'CHECK_ACTUAL_HEALTH_PERMISSION' },
      'HEALTH_PERMISSION_CHECK_RESULT',
      2,
      20000
    );
  },

  // 전체 플로우 (초기화 + 데이터 조회)
  async getHealthDataWithInit() {
    try {
      //console.loglog('🚀 건강 데이터 전체 플로우 시작...');

      // 1. 초기화
      //console.loglog('1️⃣ 초기화 단계...');
      await this.init();
      //console.loglog('✅ 초기화 완료');

      // 2. 권한 확인
      //console.loglog('2️⃣ 권한 확인 단계...');
      const permission = await this.checkPermission();
      //console.loglog('✅ 권한 확인 완료:', permission);

      // 3. 권한이 없으면 요청 (Android만)
      if (!permission.permissionGranted && permission.platform === 'android') {
        //console.loglog('3️⃣ 권한 요청 단계...');
        await this.requestPermission();
        //console.loglog('✅ 권한 요청 완료');
      }

      // 4. 데이터 조회
      //console.loglog('4️⃣ 데이터 조회 단계...');
      const healthData = await this.getStepCount();
      //console.loglog('✅ 데이터 조회 완료:', healthData);

      return {
        success: true,
        data: healthData,
        permission: permission
      };
    } catch (error) {
      //console.logerror('💥 건강 데이터 전체 플로우 실패:', error);
      return {
        success: false,
        error: error.message
      };
    }
  },

  // 월간 데이터 전체 플로우
  async getMonthlyHealthDataWithInit(year, month) {
    try {
      //console.loglog(`🚀 월간 건강 데이터 전체 플로우 시작: ${year}년 ${month}월`);

      // 1. 초기화
      //console.loglog('1️⃣ 초기화 단계...');
      await this.init();
      //console.loglog('✅ 초기화 완료');

      // 2. 권한 확인
      //console.loglog('2️⃣ 권한 확인 단계...');
      const permission = await this.checkPermission();
      //console.loglog('✅ 권한 확인 완료:', permission);

      // 3. 권한이 없으면 요청 (Android만)
      if (!permission.permissionGranted && permission.platform === 'android') {
        //console.loglog('3️⃣ 권한 요청 단계...');
        await this.requestPermission();
        //console.loglog('✅ 권한 요청 완료');
      }

      // 4. 월간 데이터 조회
      //console.loglog('4️⃣ 월간 데이터 조회 단계...');
      const monthlyData = await this.getMonthlyStepCount(year, month);
      //console.loglog('✅ 월간 데이터 조회 완료:', monthlyData);

      return {
        success: true,
        data: monthlyData,
        permission: permission
      };
    } catch (error) {
      //console.logerror('💥 월간 건강 데이터 전체 플로우 실패:', error);
      return {
        success: false,
        error: error.message
      };
    }
  }
};

export const useHealthData = () => {
  const [healthData, setHealthData] = React.useState(null);
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState(null);

  const fetchHealthData = async () => {
    setLoading(true);
    setError(null);

    try {
      //console.loglog('🔄 useHealthData: 데이터 페치 시작...');
      const result = await healthAPI.getHealthDataWithInit();

      if (result.success) {
        //console.loglog('✅ useHealthData: 성공:', result.data);
        setHealthData(result.data);
      } else {
        //console.logerror('❌ useHealthData: 실패:', result.error);
        setError(result.error);
      }
    } catch (err) {
      //console.logerror('💥 useHealthData: 예외:', err.message);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return {
    healthData,
    loading,
    error,
    fetchHealthData,
    refetch: fetchHealthData
  };
};

// useMonthlyHealthData 훅
export const useMonthlyHealthData = () => {
  const [monthlyData, setMonthlyData] = React.useState(null);
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState(null);
  const [currentYear, setCurrentYear] = React.useState(new Date().getFullYear());
  const [currentMonth, setCurrentMonth] = React.useState(new Date().getMonth() + 1);

  const fetchMonthlyData = async (year = currentYear, month = currentMonth) => {
    setLoading(true);
    setError(null);

    try {
      //console.loglog(`🔄 useMonthlyHealthData: ${year}년 ${month}월 데이터 페치 시작...`);

      const result = await healthAPI.getMonthlyHealthDataWithInit(year, month);

      if (result.success) {
        //console.loglog('✅ useMonthlyHealthData: 성공:', result.data);
        setMonthlyData(result.data);
        setCurrentYear(year);
        setCurrentMonth(month);
      } else {
        //console.logerror('❌ useMonthlyHealthData: 실패:', result.error);
        setError(result.error);
      }
    } catch (err) {
      //console.logerror('💥 useMonthlyHealthData: 예외:', err.message);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  // 이전/다음 달로 이동
  const goToPreviousMonth = () => {
    let newYear = currentYear;
    let newMonth = currentMonth - 1;

    if (newMonth < 1) {
      newMonth = 12;
      newYear = currentYear - 1;
    }

    fetchMonthlyData(newYear, newMonth);
  };

  const goToNextMonth = () => {
    let newYear = currentYear;
    let newMonth = currentMonth + 1;

    if (newMonth > 12) {
      newMonth = 1;
      newYear = currentYear + 1;
    }

    // 미래 날짜는 불가
    const today = new Date();
    const nextDate = new Date(newYear, newMonth - 1, 1);

    if (nextDate <= today) {
      fetchMonthlyData(newYear, newMonth);
    }
  };

  const goToCurrentMonth = () => {
    const today = new Date();
    fetchMonthlyData(today.getFullYear(), today.getMonth() + 1);
  };

  return {
    monthlyData,
    loading,
    error,
    currentYear,
    currentMonth,
    fetchMonthlyData,
    goToPreviousMonth,
    goToNextMonth,
    goToCurrentMonth,
    refetch: () => fetchMonthlyData(currentYear, currentMonth)
  };
};

// 디버깅용 전역 객체 확장
window.healthAPIDebug = {
  instance: webHealthAPI,
  getListeners: () => Array.from(webHealthAPI.messageListeners.keys()),
  sendPing: () => webHealthAPI.sendMessageToNative({ type: 'PING' }),
  testMonthly: (year = 2025, month = 7) => {
    //console.loglog(`🧪 월간 데이터 테스트: ${year}년 ${month}월`);
    return healthAPI.getMonthlyStepCount(year, month);
  },
  testWeekly: () => {
    //console.loglog('🧪 7일간 데이터 테스트');
    return healthAPI.getWeeklyStepCount();
  },
  testDaily: () => {
    //console.loglog('🧪 일일 데이터 테스트');
    return healthAPI.getStepCount();
  },
  // 🚀 HealthKit Observer 테스트 함수들 추가
  testObserver: () => {
    if (window.HealthKitBridge) {
      //console.loglog('🧪 HealthKit Observer 테스트');
      window.HealthKitBridge.startObserver();
      setTimeout(() => {
        window.HealthKitBridge.getStatus();
        window.HealthKitBridge.getCurrentSteps();
      }, 2000);
    } else {
      //console.loglog('❌ HealthKit Bridge가 없습니다');
    }
  },
  stopObserver: () => {
    if (window.HealthKitBridge) {
      //console.loglog('🛑 HealthKit Observer 중지');
      window.HealthKitBridge.stopObserver();
    }
  }
};